module.exports = __webpack_public_path__ + "img/Slice197-1.202f8c98.png";